var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.59998 9.6C9.60006 9.16002 9.72109 8.72853 9.94983 8.35269C10.1786 7.97685 10.5062 7.67112 10.897 7.46892C11.2878 7.26672 11.7266 7.17582 12.1655 7.20617C12.6044 7.23652 13.0266 7.38694 13.3858 7.641C13.745 7.89505 14.0275 8.24296 14.2023 8.64671C14.3772 9.05045 14.4377 9.49449 14.3772 9.93029C14.3167 10.3661 14.1376 10.7769 13.8595 11.1178C13.5813 11.4587 13.2148 11.7165 12.8 11.8632C12.5659 11.946 12.3633 12.0993 12.22 12.302C12.0767 12.5047 11.9998 12.7469 12 12.9952V13.8",
    stroke: "#808080",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 16.2C11.9406 16.2 11.8826 16.2176 11.8333 16.2506C11.7839 16.2835 11.7455 16.3304 11.7228 16.3852C11.7001 16.44 11.6941 16.5003 11.7057 16.5585C11.7173 16.6167 11.7459 16.6702 11.7878 16.7121C11.8298 16.7541 11.8832 16.7827 11.9414 16.7942C11.9996 16.8058 12.0599 16.7999 12.1148 16.7772C12.1696 16.7545 12.2164 16.716 12.2494 16.6667C12.2824 16.6173 12.3 16.5593 12.3 16.5C12.3 16.4204 12.2683 16.3441 12.2121 16.2879C12.1558 16.2316 12.0795 16.2 12 16.2Z",
    stroke: "#808080",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3 12C3 14.3869 3.94821 16.6761 5.63604 18.364C7.32387 20.0518 9.61305 21 12 21C14.3869 21 16.6761 20.0518 18.364 18.364C20.0518 16.6761 21 14.3869 21 12C21 9.61305 20.0518 7.32387 18.364 5.63604C16.6761 3.94821 14.3869 3 12 3C9.61305 3 7.32387 3.94821 5.63604 5.63604C3.94821 7.32387 3 9.61305 3 12V12Z",
    stroke: "#808080",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/help.66f165f967ea4c5f4af91166fb3fbe03.svg";
export { ForwardRef as ReactComponent };